import { ServiceStatusType } from '..';
import { SubStatus } from '../apiTypes';

export const sortSailingStatusByPriority = (a, b) => {
  const map = {};
  map[SubStatus.AllSailingsCancelled] = 1;
  map[SubStatus.Disruptions] = 2;
  map[SubStatus.BeAware] = 3;
  map[SubStatus.None] = 4;

  if (map[a] < map[b]) {
    return -1;
  }

  if (map[a] > map[b]) {
    return 1;
  }

  return 0;
};

export const sortRouteSailingStatusByPriority = (a, b) => {
  const map = {};
  map[SubStatus.AllSailingsCancelled] = 1;
  map[SubStatus.Disruptions] = 2;
  map[SubStatus.BeAware] = 3;
  map[SubStatus.None] = 4;

  if (map[a.status] < map[b.status]) {
    return -1;
  }

  if (map[a.status] > map[b.status]) {
    return 1;
  }

  return 0;
};

export const sortRouteServiceStatusTypeByPriority = (a, b) => {
  const map = {};
  map[ServiceStatusType.Cancelled] = 1;
  map[ServiceStatusType.Disruption] = 2;
  map[ServiceStatusType.AtRisk] = 3;
  map[ServiceStatusType.Normal] = 4;

  if (map[a.status] < map[b.status]) {
    return -1;
  }

  if (map[a.status] > map[b.status]) {
    return 1;
  }

  return 0;
};
